import React from "react";
import { Container, Row, Col, Breadcrumb, Form, Button } from "react-bootstrap";
import { contactFormData } from "../../../firebase";

//img
import contact from "../../../assets/images/contact.png";

const Contact = () => {
  const [fname, setFname] = React.useState("");
  const [lname, setLname] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [show, setShow] = React.useState(false);

  const handleSubmit = (e) => {
    setShow(true);
    const data = {
      fname: fname,
      lname: lname,
      email: email,
      phone: phone,
      message: message,
    };
    setTimeout(() => {
      contactFormData(data);
      setFname("");
      setLname("");
      setEmail("");
      setPhone("");
      setMessage("");
      alert("Your message has been sent successfully");
      window.location.reload();
    }, 2000);
  };

  return (
    <>
      <div
        className="iq-breadcrumb-one  iq-bg-over iq-over-dark-50"
        style={{ backgroundImage: `url(${contact})` }}
      >
        <Container fluid>
          <Row className="align-items-center">
            <Col sm="12">
              <nav
                aria-label="breadcrumb"
                className="text-center iq-breadcrumb-two"
              >
                <h2 className="title">Contact</h2>
                <Breadcrumb className="main-bg">
                  <Breadcrumb.Item>Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Contact</Breadcrumb.Item>
                </Breadcrumb>
              </nav>
            </Col>
          </Row>
        </Container>
      </div>
      <main id="main" className="site-main">
        <Container>
          <Row>
            <Col lg="12" sm="12" style={{ paddingLeft: 0 }}>
              <Row
                className="contact-detail text-center"
                style={{ paddingBottom: "1rem" }}
              >
                <Col md="4" style={{ paddingLeft: 0 }}>
                  <div className="icon-box">
                    <span className="icon-svg icon-svg d-flex justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style={{ enableBackground: "new 0 0 512 512" }}
                      >
                        {" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M256,0C156.748,0,76,80.748,76,180c0,33.534,9.289,66.26,26.869,94.652l142.885,230.257 c2.737,4.411,7.559,7.091,12.745,7.091c0.04,0,0.079,0,0.119,0c5.231-0.041,10.063-2.804,12.75-7.292L410.611,272.22 C427.221,244.428,436,212.539,436,180C436,80.748,355.252,0,256,0z M384.866,256.818L258.272,468.186l-129.905-209.34 C113.734,235.214,105.8,207.95,105.8,180c0-82.71,67.49-150.2,150.2-150.2S406.1,97.29,406.1,180 C406.1,207.121,398.689,233.688,384.866,256.818z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                        <g>
                          {" "}
                          <g>
                            {" "}
                            <path d="M256,90c-49.626,0-90,40.374-90,90c0,49.309,39.717,90,90,90c50.903,0,90-41.233,90-90C346,130.374,305.626,90,256,90z M256,240.2c-33.257,0-60.2-27.033-60.2-60.2c0-33.084,27.116-60.2,60.2-60.2s60.1,27.116,60.1,60.2 C316.1,212.683,289.784,240.2,256,240.2z"></path>{" "}
                          </g>{" "}
                        </g>{" "}
                        <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
                        <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
                        <g> </g> <g> </g> <g> </g>{" "}
                      </svg>
                    </span>
                  </div>
                  <div className="icon-box-content">
                    <h3 className="icon-box-title">
                      <span>Address</span>
                    </h3>
                    <p className="icon-box-description">
                      Home Screen Entertainment FZE,<br></br>
                      Fujairah - Creative Tower P.O Box 4422
                    </p>
                  </div>
                </Col>
                <Col md="4">
                  <div className="iq-contact-list" data-element_type="column">
                    <div className="icon-box" style={{ paddingLeft: "1rem" }}>
                      <span className="icon-svg icon-svg d-flex justify-content-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Capa_1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 473.806 473.806"
                          style={{
                            enableBackground: "new 0 0 473.806 473.806",
                          }}
                        >
                          {" "}
                          <g>
                            {" "}
                            <g>
                              {" "}
                              <path d="M374.456,293.506c-9.7-10.1-21.4-15.5-33.8-15.5c-12.3,0-24.1,5.3-34.2,15.4l-31.6,31.5c-2.6-1.4-5.2-2.7-7.7-4 c-3.6-1.8-7-3.5-9.9-5.3c-29.6-18.8-56.5-43.3-82.3-75c-12.5-15.8-20.9-29.1-27-42.6c8.2-7.5,15.8-15.3,23.2-22.8 c2.8-2.8,5.6-5.7,8.4-8.5c21-21,21-48.2,0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5c-6-6.2-12.3-12.6-18.8-18.6 c-9.7-9.6-21.3-14.7-33.5-14.7s-24,5.1-34,14.7c-0.1,0.1-0.1,0.1-0.2,0.2l-34,34.3c-12.8,12.8-20.1,28.4-21.7,46.5 c-2.4,29.2,6.2,56.4,12.8,74.2c16.2,43.7,40.4,84.2,76.5,127.6c43.8,52.3,96.5,93.6,156.7,122.7c23,10.9,53.7,23.8,88,26 c2.1,0.1,4.3,0.2,6.3,0.2c23.1,0,42.5-8.3,57.7-24.8c0.1-0.2,0.3-0.3,0.4-0.5c5.2-6.3,11.2-12,17.5-18.1c4.3-4.1,8.7-8.4,13-12.9 c9.9-10.3,15.1-22.3,15.1-34.6c0-12.4-5.3-24.3-15.4-34.3L374.456,293.506z M410.256,398.806 C410.156,398.806,410.156,398.906,410.256,398.806c-3.9,4.2-7.9,8-12.2,12.2c-6.5,6.2-13.1,12.7-19.3,20 c-10.1,10.8-22,15.9-37.6,15.9c-1.5,0-3.1,0-4.6-0.1c-29.7-1.9-57.3-13.5-78-23.4c-56.6-27.4-106.3-66.3-147.6-115.6 c-34.1-41.1-56.9-79.1-72-119.9c-9.3-24.9-12.7-44.3-11.2-62.6c1-11.7,5.5-21.4,13.8-29.7l34.1-34.1c4.9-4.6,10.1-7.1,15.2-7.1 c6.3,0,11.4,3.8,14.6,7c0.1,0.1,0.2,0.2,0.3,0.3c6.1,5.7,11.9,11.6,18,17.9c3.1,3.2,6.3,6.4,9.5,9.7l27.3,27.3 c10.6,10.6,10.6,20.4,0,31c-2.9,2.9-5.7,5.8-8.6,8.6c-8.4,8.6-16.4,16.6-25.1,24.4c-0.2,0.2-0.4,0.3-0.5,0.5 c-8.6,8.6-7,17-5.2,22.7c0.1,0.3,0.2,0.6,0.3,0.9c7.1,17.2,17.1,33.4,32.3,52.7l0.1,0.1c27.6,34,56.7,60.5,88.8,80.8 c4.1,2.6,8.3,4.7,12.3,6.7c3.6,1.8,7,3.5,9.9,5.3c0.4,0.2,0.8,0.5,1.2,0.7c3.4,1.7,6.6,2.5,9.9,2.5c8.3,0,13.5-5.2,15.2-6.9 l34.2-34.2c3.4-3.4,8.8-7.5,15.1-7.5c6.2,0,11.3,3.9,14.4,7.3c0.1,0.1,0.1,0.1,0.2,0.2l55.1,55.1 C420.456,377.706,420.456,388.206,410.256,398.806z"></path>{" "}
                              <path d="M256.056,112.706c26.2,4.4,50,16.8,69,35.8s31.3,42.8,35.8,69c1.1,6.6,6.8,11.2,13.3,11.2c0.8,0,1.5-0.1,2.3-0.2 c7.4-1.2,12.3-8.2,11.1-15.6c-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3,3.7-15.6,11 S248.656,111.506,256.056,112.706z"></path>{" "}
                              <path d="M473.256,209.006c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2,3.7-15.5,11 c-1.2,7.4,3.7,14.3,11.1,15.6c46.6,7.9,89.1,30,122.9,63.7c33.8,33.8,55.8,76.3,63.7,122.9c1.1,6.6,6.8,11.2,13.3,11.2 c0.8,0,1.5-0.1,2.3-0.2C469.556,223.306,474.556,216.306,473.256,209.006z"></path>{" "}
                            </g>{" "}
                          </g>{" "}
                          <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
                          <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
                          <g> </g> <g> </g> <g> </g>{" "}
                        </svg>
                      </span>
                    </div>
                    <div
                      className="icon-box-content"
                      style={{ paddingLeft: "1rem" }}
                    >
                      <h3
                        className="icon-box-title"
                        style={{ fontWeight: "300" }}
                      >
                        <span>Anytime Call</span>
                      </h3>
                      <p className="icon-box-description">+97142387974</p>
                    </div>
                  </div>
                </Col>
                <Col md="4">
                  <div
                    className="iq-contact-list"
                    data-element_type="column"
                    style={{ paddingLeft: "3rem" }}
                  >
                    <div className="icon-box">
                      <span className="icon-svg icon-svg d-flex justify-content-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Capa_1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          style={{ enableBackground: "new 0 0 512 512" }}
                        >
                          {" "}
                          <g>
                            {" "}
                            <g>
                              {" "}
                              <path d="M467,80.609H45c-24.813,0-45,20.187-45,45v260.782c0,24.813,20.187,45,45,45h422c24.813,0,45-20.187,45-45V125.609 C512,100.796,491.813,80.609,467,80.609z M461.127,110.609l-6.006,5.001L273.854,266.551c-10.346,8.614-25.364,8.614-35.708,0 L56.879,115.61l-6.006-5.001H461.127z M30,132.267L177.692,255.25L30,353.543V132.267z M467,401.391H45 c-7.248,0-13.31-5.168-14.699-12.011l171.445-114.101l17.204,14.326c10.734,8.938,23.893,13.407,37.051,13.407 c13.158,0,26.316-4.469,37.051-13.407l17.204-14.326l171.444,114.1C480.31,396.224,474.248,401.391,467,401.391z M482,353.543 l-147.692-98.292L482,132.267V353.543z"></path>{" "}
                            </g>{" "}
                          </g>{" "}
                          <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
                          <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
                          <g> </g> <g> </g> <g> </g>{" "}
                        </svg>{" "}
                      </span>
                    </div>
                    <div className="icon-box-content">
                      <h3 className="icon-box-title">
                        <span>Email Us</span>
                      </h3>
                      <p className="icon-box-description">
                        info@homescreenentertainment.ae
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <div
                className="text-center iq-title-box iq-box iq-title-default"
                style={{ paddingTop: "1rem" }}
              >
                <h2 className="iq-title">Say Hello..!</h2>
                <p className="iq-title-desc">
                  Fill up this form to reach our stunning Homescreen
                  Entertainment team and click on send message.{" "}
                </p>
              </div>
              <div className="wrapper">
                <div className="contact-form contact-style">
                  <Row>
                    <Col md="6">
                      <div className="cfield">
                        <span className="wpcf7-form-control-wrap your-name">
                          <input
                            type="text"
                            name="firstname"
                            size="40"
                            className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            placeholder="First Name"
                            onChange={(e) => setFname(e.target.value)}
                            style={{
                              backgroundColor: "#1e1e1e",
                              color: "#fff",
                              borderColor: "rgba(128, 128, 128, 0.5)",
                              fontWeight: "100",
                            }}
                          />
                        </span>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="cfield">
                        <span className="wpcf7-form-control-wrap your-subject">
                          <input
                            type="text"
                            name="lastname"
                            size="40"
                            className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            placeholder="Last Name"
                            onChange={(e) => setLname(e.target.value)}
                            style={{
                              backgroundColor: "#1e1e1e",
                              color: "#fff",
                              borderColor: "rgba(128, 128, 128, 0.5)",
                              fontWeight: "100",
                            }}
                          />
                        </span>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="cfield">
                        <span className="wpcf7-form-control-wrap tel-478">
                          <input
                            type="tel"
                            name="phone"
                            size="40"
                            maxLength="140"
                            minLength="10"
                            className="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel"
                            aria-required="true"
                            aria-invalid="false"
                            placeholder="Phone Number"
                            onChange={(e) => setPhone(e.target.value)}
                            style={{
                              backgroundColor: "#1e1e1e",
                              color: "#fff",
                              borderColor: "rgba(128, 128, 128, 0.5)",
                              fontWeight: "100",
                            }}
                          />
                        </span>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="cfield">
                        <span className="wpcf7-form-control-wrap your-email">
                          <input
                            type="email"
                            name="email"
                            size="40"
                            className="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                            aria-required="true"
                            aria-invalid="false"
                            placeholder="Your Email"
                            onChange={(e) => setEmail(e.target.value)}
                            style={{
                              backgroundColor: "#1e1e1e",
                              color: "#fff",
                              borderColor: "rgba(128, 128, 128, 0.5)",
                              fontWeight: "100",
                            }}
                          />
                        </span>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="cfield">
                        <span className="wpcf7-form-control-wrap your-message">
                          <textarea
                            name="message"
                            cols="40"
                            rows="10"
                            className="wpcf7-form-control wpcf7-textarea wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            placeholder="Your Message"
                            style={{
                              backgroundColor: "#1e1e1e",
                              color: "#fff",
                              borderColor: "rgba(128, 128, 128, 0.5)",
                              fontWeight: "100",
                            }}
                            onChange={(e) => setMessage(e.target.value)}
                          ></textarea>
                        </span>
                        <p className="wpcf7-form-control-wrap your-message">
                          We don't share your personal info with anyone.
                        </p>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button
                        id="submit"
                        name="submit"
                        variant="hover iq-button"
                        onClick={() => handleSubmit()}
                      >
                        <span
                          className="header-cta"
                          style={{
                            fontWeight: 500,
                          }}
                        >
                          Send Message
                        </span>
                        <span className="iq-btn-icon-holder">
                          <i aria-hidden="true" className="ion ion-plus"></i>
                        </span>
                        <br />
                      </Button>
                    </Col>
                  </Row>
                </div>
                <div className="wpcf7-response-output" aria-hidden="true"></div>
              </div>
            </Col>
          </Row>
        </Container>
      </main>
    </>
  );
};
export default Contact;
